import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(private translate: TranslateService) {}

  private errorMap: { [key: string]: string } = {
    invalid_credentials: 'ERRORS.DJOSER.invalid_credentials',
    user_not_found: 'ERRORS.DJOSER.user_not_found',
    invalid_token: 'ERRORS.DJOSER.invalid_token',
    password_mismatch: 'ERRORS.DJOSER.password_mismatch',
    'This password is too weak': 'ERRORS.DJOSER.weak_password',
    'A user with that email already exists': 'ERRORS.DJOSER.email_already_exists',
    'Enter a valid email address.': 'ERRORS.DJOSER.invalid_email',
    'This account is disabled': 'ERRORS.DJOSER.account_disabled',
    'This password is too common': 'ERRORS.DJOSER.password_too_common',
    'This password is too short': 'ERRORS.DJOSER.password_too_short',
    'This field is required': 'ERRORS.DJOSER.required_field',
    'Invalid password': 'ERRORS.DJOSER.invalid_current_password',
    'This email is already registered. Please log in or reset your password. In case of trouble, contact support.':
      'ERRORS.DJOSER.email_already_registered',
    'A user with that username already exists.': 'ERRORS.DJOSER.username_already_exists',
    'User already exists': 'ERRORS.DJOSER.user_already_exists',
    'User not found': 'ERRORS.DJOSER.user_not_found',
    'Email does not match signup link': 'ERRORS.AUTH.email_does_not_match_signup_link',
  };

  translateError(error: any): string {
    if (error && typeof error === 'object') {
      const firstKey = Object.keys(error)[0];
      if (firstKey && Array.isArray(error[firstKey])) {
        const errorMessage = error[firstKey][0];
        return this.getTranslation(errorMessage);
      }
      if (error.detail) {
        return this.getTranslation(error.detail);
      }
      if (error.non_field_errors && Array.isArray(error.non_field_errors)) {
        return this.getTranslation(error.non_field_errors[0]);
      }
    }
    if (typeof error === 'string') {
      return this.getTranslation(error);
    }

    return this.translate.instant('ERRORS.DEFAULT');
  }

  private getTranslation(errorMessage: string): string {
    if (this.errorMap[errorMessage]) {
      return this.translate.instant(this.errorMap[errorMessage]);
    }

    for (const [key, translationKey] of Object.entries(this.errorMap)) {
      if (errorMessage.toLowerCase().includes(key.toLowerCase())) {
        return this.translate.instant(translationKey);
      }
    }

    return errorMessage;
  }

  translateErrors(errors: any): string[] {
    const messages: string[] = [];

    if (errors && typeof errors === 'object') {
      Object.keys(errors).forEach(key => {
        if (Array.isArray(errors[key])) {
          errors[key].forEach((msg: string) => {
            messages.push(this.getTranslation(msg));
          });
        } else {
          messages.push(this.getTranslation(errors[key]));
        }
      });
    }

    return messages.length > 0 ? messages : [this.translate.instant('ERRORS.DEFAULT')];
  }
}
